import React from 'react'
import IconsContainer from "Utils/IconsContainer";
import Popup from "Components/Common/popup";

const SettingsBlock = (props) =>
    <div
        id={props.id}
        key={props.key}
        className={'settings-block ' + (props.className == null ? '' : props.className)}>
        <div
            className="settings-block-title"
            onClick={e => {
                if (props.onTitleClick != null) props.onTitleClick(e)
            }}>
            {props.title}
            {((props.description != null) ?
                <Popup
                    popupText={props.description}
                    className='fast-info-popup'>
                    {IconsContainer.Get('ci-info')}
                </Popup> : '')}
        </div>
        {props.children}
    </div>

export default SettingsBlock;